/*
As an admin of an organization through Love Big, I want an organized list of projects
I've created through the website, so that I can easily access a project I would like to view/update
*/

//Packages
import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
//Material UI Components
import {
  Button,
  Grid,
  CircularProgress,
  Typography,
  Stack,
  CardContent,
  CardMedia,
  Card,
  CardActions,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
//API Route
import { Route } from "../../utils/config";
//Context
import { userContext } from "../../Context";
//Assets
import placeholderImg from "../../assets/images/placeholderLg.png";

//Material UI Styles
const useStyles = makeStyles({
  button: {
    textDecoration: "none",
  },
});

export default function Projects() {
  const { user } = useContext(userContext);
  const [projects, setProjects] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const styles = useStyles();

  useEffect(() => {
    const getData = () => {
      let store = JSON.parse(localStorage.getItem("login"));

      axios
        .get(`${Route}/Projects/GetPartnerProjects`, {
          params: {
            partnerId: user.partnerId,
          },
          headers: { Authorization: `Bearer ${store.token}` },
        })
        .then((res) => {
          setProjects(res.data);
          setIsLoading(false);
        })
        .catch((err) => {
          throw err;
        });
    };
    getData();
    window.scrollTo(0, 0);
  }, [user]);

  return (
    <Grid item xs={12} height={{ md: "960px" }}>
      <Grid
        container
        item
        xs={12}
        mt={{ xs: 3, md: 0 }}
        justifyContent="space-evenly"
        alignItems={{ xs: "center", md: "unset" }}
        height="100%"
      >
        <Grid
          container
          justifyContent={{ xs: "center", md: "space-around" }}
          alignItems="center"
          zIndex={2}
          height={{ md: "60px" }}
          backgroundColor="#ffffff"
        >
          <Grid item xs={12} md={6} textAlign="center" mb={{ xs: 1, md: 0 }}>
            <Typography variant="h4">My Projects</Typography>
          </Grid>

          <Grid item xs={12} md={6} textAlign="center">
            {" "}
            <Link to="/profile/projects/new" className={styles.button}>
              <Button variant="contained" color="light">
                Create a new project +
              </Button>
            </Link>
          </Grid>
        </Grid>
        <Grid container item justifyContent="center">
          {!isLoading ? (
            <Grid
              container
              item
              spacing={3}
              mb={{ xs: 6, md: 0 }}
              pb={{ md: 2 }}
              px={{ md: "20px" }}
              height={{ md: "870px" }}
              overflow={{ md: "visible scroll" }}
              width="90%"
            >
              {projects.map((project) => {
                return (
                  <Grid item key={project.id} xs={12} sm={6} xl={4}>
                    <Card>
                      <CardMedia
                        component="img"
                        height="140"
                        src={placeholderImg}
                        alt="Gray placeholder"
                      />
                      <CardContent>
                        <Grid container pb={2}>
                          <Grid item xs={11}>
                            <Stack>
                              <Typography
                                variant="h6"
                                component="div"
                                whiteSpace="nowrap"
                                textOverflow="ellipsis"
                                display="block"
                                overflow="hidden"
                              >
                                {project.name}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {project.projectType
                                  ? project.projectType
                                  : "No project type"}
                              </Typography>
                            </Stack>
                          </Grid>
                        </Grid>

                        <Typography
                          variant="body2"
                          color="text.secondary"
                          minHeight={42}
                        >
                          {project.overview ? (
                            <>
                              {project.overview.length > 50
                                ? `${project.overview.slice(0, 50)}...`
                                : project.overview}
                            </>
                          ) : (
                            "No Overview"
                          )}
                        </Typography>
                      </CardContent>
                      <CardActions>
                        <Button color="primary" variant="contained">
                          <Link
                            to={`/project/${project.id}`}
                            state={{ id: project.id }}
                            style={{
                              color: "#FFFFFF",
                              textDecoration: "none",
                            }}
                          >
                            View Project
                          </Link>
                        </Button>
                        <Button color="primary" variant="contained">
                          <Link
                            to={`/profile/editproject/${project.id}`}
                            state={{ id: project.id }}
                            style={{
                              color: "#FFFFFF",
                              textDecoration: "none",
                            }}
                          >
                            Edit Project
                          </Link>
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          ) : (
            <Grid container justifyContent="center" mt={2} mb={2}>
              <Grid item>
                <CircularProgress></CircularProgress>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
